export default __webpack_public_path__ + "static/media/plant-shop-circle.227972d5.png";